import { useAuthStore } from '@/stores/authStore'

export const LANDING_PAGE_IMPORT_REQUEST_EVENT = 'landing-page-import-requested'

let pendingImport: { files: File[]; userId: number } | null = null

export function queueLandingPageImport(files: FileList | File[]): boolean {
  const userId = useAuthStore().user?.userId
  if (!userId) {
    pendingImport = null
    return false
  }

  pendingImport = { files: Array.from(files), userId }
  window.dispatchEvent(new CustomEvent(LANDING_PAGE_IMPORT_REQUEST_EVENT))
  return true
}

export function hasPendingLandingPageImport(): boolean {
  return pendingImport !== null
}

export function cancelPendingLandingPageImport(): void {
  pendingImport = null
}

export function consumePendingLandingPageImport(destination: {
  isPinnedRoute: boolean
  workspaceClientId: string | null
  systemKey: string | null
}): File[] {
  if (!pendingImport) return []

  const request = pendingImport
  pendingImport = null
  if (useAuthStore().user?.userId !== request.userId) {
    throw new Error('Account changed before the import destination was ready')
  }
  if (
    !destination.isPinnedRoute ||
    !destination.workspaceClientId ||
    destination.systemKey !== 'pinned'
  ) {
    throw new Error('Pinned was not ready as the import destination')
  }

  return request.files
}
